<template>
  <!-- Modale per la visualizzazione dello stato dei crediti     -->
  <!-- attivi ( credito spendibile e contabile )                 -->
  <div>
    <b-modal size="xl"
             no-close-on-backdrop
             no-close-on-esc
             hide-header-close
             scrollable
             title="Stato dei crediti in corso di validità."
             v-model="open_close_modal">
      <template v-slot:default>
        <b-row>
          <b-col>
            <p>In questa tabella è riportato lo stato dei soli crediti <b>in corso di validità</b>.</p>
            <p>Per ogni credito sono mostrati tre valori:</p>
            <ul>
              <li><b>Credito Iniziale:</b> il valore iniziale del credito senza il conteggio delle spese fatte.</li>
              <li><b>Credito Spendibile:</b> valore residuo del credito a fronte delle spese fatte.</li>
              <li><b>Credito Contabile:</b> valore residuo del credito conteggiando le sole spese in stato pagato.</li>
            </ul>
          </b-col>
        </b-row>
        <!-- QUI LA TABELLA --->
        <b-row>
          <b-col>
            <!-- Siccome questa tabella dovrà visualizzare solo i crediti attivi -->
            <!-- non usiamo la paginazione, anche perchè tra l'altro neanche la  -->
            <!-- chiamata web la usa.                                            -->
            <b-table responsive
                    :items="get_table_items"
                    :fields="datatable.fields"
                    hover
                    show-empty>

              <!-- Slot per la colonna della data decorrenza, la mettiamo nel formato italiano -->
              <template v-slot:cell(data_decorrenza)="data">
                {{data.item.data_decorrenza | toitadate}}
              </template>

              <!-- Slot per la colonna della data scadenza, la mettiamo nel formato italiano -->
              <template v-slot:cell(data_scadenza)="data">
                {{data.item.data_scadenza | toitadate}}
              </template>

              <!-- Slot per la colonna della fonte welfare, costruiamo le info a partire dall'oggetto -->
              <!-- con le info sulla fonte -->
              <template v-slot:cell(fonte)="data">
                {{data.item.fonte.nome}}
              </template>

              <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
                  chiamata la funzione che prende i dati get_table_items --->
              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
                  <strong class="text-primary">Caricamento...</strong>
                  <p class="text-primary mt-3">Potrebbero essere necessari alcuni istanti per visualizzare i dati, attendere.</p>
                </div>
              </template>

              <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
                  la proprietà "show-empty" alla tabella -->
              <template v-slot:empty>
                <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento presente</p>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </template>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="primary" @click="open_close_modal = false">Chiudi</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'CredStatusModal',
  data () {
    return {

      // TABELLA MOVIMENTI
      // Oggetto con le info per la tabella
      datatable : {

        // Definizione delle colonne per la tabella.
        fields: [
          {
            key: 'id',
            label: 'Id Credito',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'data_decorrenza',
            label : 'Data Decorrenza',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key : 'data_scadenza',
            label: 'Data Scadenza',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key : 'fonte',
            label: 'Tipologia Fonte Welfare',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key : 'credito_iniziale',
            label: 'Credito Iniziale €',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key : 'credito_spendibile',
            label: 'Credito Spendibile €',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key : 'credito_contabile',
            label: 'Credito Contabile €',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          }
        ]
      }
    }
  },
  methods: {
    /**
     * Funzione per prendere gli item della tabella
     * da backend.
     */
    get_table_items : function ( ctx, callback ) {

      axios.get( apiUrl.pdoppiaapi.get_user_credit_info )
      .then( ( response ) => {

        // La risposta torna anche alcuni elementi in più oltre ai crediti
        // come nome, cognome e codice fiscale dell'utente che a noi però
        // non servono
        callback( response.data.crediti );

      })
      .catch( ( error ) => {
        let error_message = 'Non è stato possibile caricare i dati. Contattare ' +
                            'l\'assistenza se il problema persite.';
        generalLib.backend_error_message_box( this, error_message );
        console.error( 'Errore di calcolo LiteBridge: ' + error.response.data );
        callback ( [] );
      });

    }
  },
  computed : {
    /* Questa computed può essere anche settata ed è di supporto al v-model, viene
       agganciata al v-model della b-modal per aprirla e chiuderla.
       Quando il valore della prop viene settato ( a true ad esempio perchè vogliamo
       aprire la modale ), viene eseguito il metodo get che restituisce il valore
       stesso della property ( true ) ed apre la modale.
       Al click sul pulsante "chiudi" la computed viene settata a false ( voglio chiudere
       la modale ), questo fa si che sia eseguito il set il quale emette l'evento close
       e torna il valore false.
       Avendo definito in "model" l'evento close come evento di update del v-model,
       registrato l'evento, il suo valore (false) viene settato nella property dal chiamante
       e la finestra si chiude! In questo modo la propery non viene mutata direttamente da
       dal componente stesso. */
    open_close_modal : {
      get() {
        return this.show_modal;
      },
      set(value) {
        this.$emit( 'close', value );
      }
    }
  },
  /* Definendo model possiamo agganciare al componente un suo v-model,
     il quale, pilotato dal componente parent può aprire o chiudere la finestra.
     Il valore del v-model sarà sempre passato alla prop show_modal, allo scattare
     dell'evento close il v-model sarà updatato.
     In questo modo si evita la modifica da dentro il componente della
     prop che è un antipattern e viene segnalato come errore. */
  model : {
    prop: 'show_modal',
    event: 'close'
  },
  props : {
    /**
     * Booleano che indica se visualizzare o meno la modale.
     */
    show_modal : {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
</style>